export const SINGER_COMPANY_IDS = [3246, 3177] as const;

type SingerCompanyId = (typeof SINGER_COMPANY_IDS)[number];

export const isSingerCompany = (companyId?: number): boolean =>
  typeof companyId === 'number' &&
  SINGER_COMPANY_IDS.includes(companyId as SingerCompanyId);

export const SINGER_LABEL_OVERRIDES: Record<string, string> = {
  'Stock Info Is Stock Product': 'Stocked',
  'In Stock': 'Available',
  'In stock': 'Available',
  'Out of Stock': 'Not Available',
  'Out of stock': 'Not Available',
  Stock: 'Stocked'
};

export const SINGER_FACET_LABEL_OVERRIDES = SINGER_LABEL_OVERRIDES;

export const getSingerLabel = (label: string, companyId?: number): string => {
  if (!isSingerCompany(companyId)) return label;
  return SINGER_LABEL_OVERRIDES[label] ?? label;
};
